import Hospitalizations from "assets/menu-icons/Hospitalizations";

const hospitalizations = {
  id: 'hospitalizations',
  type: 'group',
  children: [{
    id: 'hospitalizations',
    title: 'Запись на госпитализацию',
    type: 'item',
    url: '/hospitalizations',
    icon: Hospitalizations,
    breadcrumbs: false
  }]
}

export default hospitalizations;
